export function deriveInitials(email: string): string {
  const raw = email.split('@')[0];
  if (!raw) return '?';
  const parts = raw.split('.').filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  const local = parts[0] || raw.replace(/\./g, '');
  if (!local) return '?';
  return local.slice(0, 2).toUpperCase();
}
